export const INSPECTION_DATA_CHANGED_EVENT = 'kop:inspection-data-changed';

/**
 * Announces a server-receipted inspection mutation to every mounted projection.
 * Consumers invalidate their session caches before starting a bounded refresh.
 */
export function notifyInspectionDataChanged() {
  if (typeof window !== 'undefined') window.dispatchEvent(new Event(INSPECTION_DATA_CHANGED_EVENT));
}
